<template>
	<div class="ms-button">
		<button
			class="ms-button-item"
			:class="[`justify-${align}`, type, cssClass]"
			:disabled="disabled"
			v-on="listeners"
			:tabIndex="tabIndex"
		>
			<div
				class="w-full"
				:class="icon"
				v-if="icon && iconPlacement == 'top'"
			></div>
			<div :class="icon" v-if="icon && iconPlacement == 'left'"></div>
			<div class="ms-button-text" :class="{ 'is-bold': isBold }">
				{{ title }}
			</div>
			<div :class="icon" v-if="icon && iconPlacement == 'right'"></div>
		</button>
	</div>
</template>
<script>
export default {
	name: 'msButton',
	props: {
		//Tiêu đề hiện thị trên button
		title: {
			defualt: null,
			type: String,
		},
		//Icon đi kìm với title của button
		icon: {
			default: null,
			type: [String],
		},
		//Chỉnh vị trí cho text trong button
		align: {
			default: 'center',
			type: String,
		},
		//Loại button gồm 3 loại primary/secondary/third/four để hiện thị style tương ứng
		type: {
			default: 'primary',
			type: String,
		},
		/**
		 * css để bên ngoài control có thể custom lại được style của button
		 */
		cssClass: {
			default: null,
			type: String,
		},
		/**
		 * Trạng thái button disabled
		 */
		disabled: {
			default: false,
			type: Boolean,
		},
		isBold: {
			default: false,
			type: Boolean,
		},
		iconPlacement: {
			default: 'left',
			type: String,
		},
		tabIndex: {
			default: 0,
			type: Number,
		},
	},
	data() {
		return {};
	},
	computed: {
		//Sự kiện từ 1 dòng dữ liệu emit ra ngoài
		listeners() {
			const me = this;
			return {
				click: (event) => {
					me.$emit('click', event);
				},
				mousedown: (event) => {
					event.preventDefault();
				},
				keydown: (event) => {
					me.$emit('keydown', event);
				},
				focus: (event) => {
					me.$emit('focus', event);
				},
			};
		},
	},
};
</script>
<style scoped lang="scss">
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/components/msButton.scss';
}
@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/msButton.scss';
}
</style>

